import { jsx } from "react/jsx-runtime";
const SvgEqualizer = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z", fill: "currentColor" }) });
export default SvgEqualizer;
